import { Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { PropertiesProcFINComponent } from '../properties-proc-fin/properties-proc-fin.component';
import { Annexe } from 'src/app/Interfaces/Libraries/Library-FIN-int/File_FIN.interface';
import { FormBuilder, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { Response_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Response_FIN.interface';
import { firstValueFrom } from 'rxjs';

/**
 * Component for managing annexe properties in the FIN module.
 *
 * This component allows users to view and update annexe properties.
 * It provides form validation, integrates with SweetAlert for user interactions,
 * and emits events when properties change.
 *
 * @component
 * @example
 * <app-properties-anne-fin [annexeUpdate]="annexe"></app-properties-anne-fin>
 */
@Component({
    selector: 'app-properties-anne-fin',
    templateUrl: './properties-anne-fin.component.html',
    styleUrls: ['./properties-anne-fin.component.scss', '../../../../../Styles/GlobalStyles.css', '../../../../../Styles/LibrayGlobal.css'],
    standalone: false
})
export class PropertiesAnneFINComponent extends PropertiesProcFINComponent implements OnChanges {

  //+============== INPUT ===============+\\
  @Input({ required: true }) public annexeUpdate!: Annexe

  //+============== OUTPUT ===============+\\
  @Output() IsChangeAnnexeFINEm = new EventEmitter<boolean>();

  //+===================== SERVICES =====================+\\
  private readonly formBuilder: FormBuilder = inject(FormBuilder)

  //+============== FORMS ===============+\\
  public formAnnexe = this.formBuilder.nonNullable.group({
    ID: [0, [Validators.required, Validators.pattern(/\d+/)]],
    Name: ['', [Validators.required, Validators.pattern(`([^\\/:*?"<>|]*)`)]]
  })

  //&====================== LIFE CYCLES ======================&\\
  /**
   * Angular lifecycle hook triggered when input properties change.
   * Updates the form fields with new annexe data.
   *
   * @param {SimpleChanges} changes - The changes in input properties.
   * @returns {void}
   */
  override ngOnChanges(changes: SimpleChanges): void {
    if (changes["annexeUpdate"] && this.annexeUpdate) {
      const nameAnnexe: string = this.annexeUpdate.Name.split(".").shift() || "";
      this.formAnnexe.patchValue({ ID: this.annexeUpdate.ID, Name: nameAnnexe });
    }
  }

  //&====================== TO UPDATE ANNEXE ======================&\\
  /**
   * Updates annexe properties after validation and confirmation.
   * Shows a confirmation modal before proceeding.
   *
   * @public
   * @returns {void}
   */
  public UpdatePropertiesAnnexeFIN(): void {
    if (!this.validationFormUpdateAnnexe()) return;

    const extension: string = this.annexeUpdate.Name.split(".").pop() || "";
    const nameAnnexe: string = this.formAnnexe.value.Name + "." + extension;

    const SendAnnexe: Partial<Annexe> = {
      ID: this.annexeUpdate.ID,
      Name: nameAnnexe,
    }

    Swal.fire({
      title: '¿Los datos son correctos?',
      text: `Estas modificando las propiedades de ${nameAnnexe}`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: '¡Sí, son correctos!',
      cancelButtonText: 'No, Cancelar',
    }).then(async (result) => {

      if (result.isConfirmed) {
        try {

          const ResUpdateFIN: Response_FIN = await firstValueFrom(this.Service_FIN.Update_Properties_Annexe_FIN(SendAnnexe));

          if (ResUpdateFIN.success) {

            Swal.fire({
              icon: 'success',
              title: 'Las propiedades del anexo se modificaron correctamente',
              confirmButtonColor: this.ColorConfirm
            })

            this.IsChangeAnnexeFINEm.emit(true);
          }

        } catch (e) {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: '¡Ocurrio un error al cambiar las propiedades del anexo, notifica a tu supervFINr!',
            confirmButtonColor: this.ColorConfirm,
          })
          this.IsChangeAnnexeFINEm.emit(true);
        }
      }
    })

  }

  /**
  * Validates the annexe form before updating.
  * Shows an alert if the form is invalid.
  *
  * @private
  * @returns {boolean} True if valid, false otherwise.
  */
  private validationFormUpdateAnnexe(): boolean {

    const IdinputNamePropAnnexeFIN = document.getElementById('IdinputNamePropAnnexeFIN') as HTMLElement;

    if (!this.formAnnexe.controls.Name.valid) {
      Swal.fire({
        title: '¡Nombre no valido!',
        text: `No se permiten los siguientes caracteres \\ / : * ? " < > |`,
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
      IdinputNamePropAnnexeFIN.classList.add('ng-invalid'); IdinputNamePropAnnexeFIN.classList.add('ng-touched');
      return false;
    }
    return true;
  }
}
